import type { Feature } from "geojson";
import type L from "leaflet";
import { isStackInventoryType } from "./inventories";

/** Read attached geometry markers so inventory visibility follows the map itself. */
export function getRenderedStackFeatures(map: L.Map, bounds: L.LatLngBounds): Feature[] {
  const features: Feature[] = [];
  map.eachLayer((layer) => {
    const marker = layer as L.Marker & {
      feature?: Feature;
      options: L.MarkerOptions & { role?: string };
    };
    if (
      marker.options.role === "geometry" &&
      marker.feature?.geometry.type === "Point" &&
      isStackInventoryType(marker.feature.properties?.inventoryType) &&
      typeof marker.getLatLng === "function" &&
      bounds.contains(marker.getLatLng())
    ) {
      features.push(marker.feature);
    }
  });
  return features;
}
